import "./packsFilterForm.scss";
import { type FilterFormPropsBase } from "../types/props";
import type PacksFilters from "enums/licensing/PacksFilters";
import { type FC } from "react";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { FeatureFlags } from "featureFlags";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { getPacksFilters } from "./packsFilters";

export interface PacksFilterFormForPacksProps extends FilterFormPropsBase<PacksFilters> {
  includePublishers?: boolean;
  includePricingType?: boolean;
}

const PacksFilterForm: FC<PacksFilterFormForPacksProps> = ({
  filterOptions,
  filter,
  updateFilter,
  includePublishers,
  includePricingType,
  onValidationChange,
}) => {
  const paidPack = useFeatureFlag(FeatureFlags.PaidPacks);

  return (
    <form className="packs-filter-form" autoComplete="off">
      <FilterFormBuilder
        filterOptions={filterOptions}
        filter={filter}
        updateFilter={updateFilter}
        items={getPacksFilters(includePublishers, paidPack && includePricingType)}
        onValidationChange={onValidationChange}
      />
    </form>
  );
};

export default PacksFilterForm;
